// extracted by mini-css-extract-plugin
export default {"hero":"styles_hero__ereIs","hero__media":"styles_hero__media__3Fzzf","hero__content":"styles_hero__content__4xrrX"};